import _asyncToGenerator from "/builds/huggg/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
/**
 * Should expand this later. Really we need some
 * dynamic type which does filters per-column,
 * but we're a bit in flux at the minute.
 *
 * @typedef {{ [columnName: string]: any }} SearchFilter
 */
/**
 * @typedef {{ [columnName: string]: 1 | -1 }} Sort
 *
 * @typedef {{
 *   filter: SearchFilter
 *   limit?: number
 *   offset?: number
 *   select?: string[]
 *   sort?: Sort
 * }} SqlSearchOptions
 *
 * @typedef {{
 *   filter: SearchFilter
 *   usePagination?: boolean
 *   next?: string | null
 *   previous?: string | null
 *   select?: string[]
 *   sort?: Sort
 * }} MongoSearchOptions
 */

import { path, prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
import v3ParamsSerializer from '../utils/v3-params-serializer';
var DEFAULT_LIMIT = 20;
var factory = function factory(slug) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mongo';
  /**
   * Fetch a singular item by ID
   *
   * @param {Object} $axios [$axios=axios] Axios instance.
   * @param {String} id
   *
   * @returns {Promise} Unresolved Promise from the API.
   */
  var single = function single($axios, id) {
    if (!id) {
      throw new Error("Parameter 'id' is required in '".concat(slug, ".single'"));
    }
    return $axios.get(urls.apiV3("/".concat(slug, "/").concat(id))).then(path(['data', 'data']));
  };
  var create = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(axios, entity) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2, axios.post(urls.apiV3("/".concat(slug)), entity).then(path(['data', 'data'])));
        }
      }, _callee);
    }));
    return function create(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var update = function update($axios, id, entity, replace) {
    return $axios.put(urls.apiV3("/".concat(slug, "/").concat(id)), {
      entity: entity,
      replace: replace
    }).then(path(['data', 'data']));
  };

  /**
   *
   * @param {Object} $axios
   * @param {MongoSearchOptions} options
   *
   * @returns {Promise} Unresolved Promise from the API.
   */
  var searchMongo = function searchMongo($axios, _ref2) {
    var filter = _ref2.filter,
      _ref2$usePagination = _ref2.usePagination,
      usePagination = _ref2$usePagination === void 0 ? true : _ref2$usePagination,
      _ref2$next = _ref2.next,
      next = _ref2$next === void 0 ? null : _ref2$next,
      _ref2$previous = _ref2.previous,
      previous = _ref2$previous === void 0 ? null : _ref2$previous,
      select = _ref2.select,
      sort = _ref2.sort;
    return $axios.post(urls.apiV3("/".concat(slug, "/searches")), {
      filter: filter,
      pagination: {
        enable: usePagination,
        next: next,
        previous: previous
      },
      select: select,
      sort: sort
    }).then(prop('data'));
  };

  /**
   *
   * @param {Object} $axios
   * @param {SqlSearchOptions} options
   *
   * @returns {Promise} Unresolved Promise from the API.
   */
  var searchSql = function searchSql($axios, _ref3) {
    var filter = _ref3.filter,
      _ref3$limit = _ref3.limit,
      limit = _ref3$limit === void 0 ? DEFAULT_LIMIT : _ref3$limit,
      _ref3$offset = _ref3.offset,
      offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
      select = _ref3.select,
      sort = _ref3.sort;
    return $axios.post(urls.apiV3("/".concat(slug, "/searches")), {
      filter: filter,
      limit: limit,
      offset: offset,
      select: select,
      sort: sort
    }).then(prop('data'));
  };
  var getAll = function getAll($axios, params) {
    return $axios.get(urls.apiV3("/".concat(slug)), {
      params: params,
      paramsSerializer: v3ParamsSerializer
    }).then(prop('data'));
  };
  return {
    search: withAxios(type === 'mongo' ? searchMongo : searchSql),
    single: withAxios(single),
    create: withAxios(create, {
      autoAuth: true,
      useBackoff: false
    }),
    update: withAxios(update, {
      autoAuth: true,
      useBackoff: false
    }),
    getAll: withAxios(getAll)
  };
};
export default factory;